import { z } from 'zod';
import { RelationshipType } from './enums.js';
export const TicketRelationship = z.object({
    id: z.string(),
    sourceTicketId: z.string(),
    targetTicketId: z.string(),
    type: RelationshipType,
    createdById: z.string().nullable(),
    createdAt: z.string(),
});
export const CreateRelationshipInput = z.object({
    targetTicketId: z.string(),
    type: RelationshipType,
});
/** Inverse mapping used to materialize the reciprocal link. */
export const INVERSE_RELATIONSHIP = {
    blocks: 'is_blocked_by',
    is_blocked_by: 'blocks',
    duplicates: 'is_duplicated_by',
    is_duplicated_by: 'duplicates',
    relates_to: 'relates_to',
    clones: 'is_cloned_by',
    is_cloned_by: 'clones',
    parent_of: 'child_of',
    child_of: 'parent_of',
    caused_by: 'caused_by',
    follow_up: 'follow_up',
    regression_of: 'regression_of',
};
//# sourceMappingURL=relationship.js.map